const IAP_STORAGE_KEY = 'jottacloud.iap'

function searchParams(search: string) {
  return new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
}

/**
 * The Jottacloud Android app adds ?iap=true only for the Jottacloud flavor,
 * and only when the account is free or Play-billed. Card customers and other
 * brands stay out of this context. The app can open any page with that param.
 * Client navigations drop search params, so the flag is kept for this tab.
 * RootRoutes captures the landing URL once, before the first page renders.
 */
export function captureIapQuery(search: string) {
  if (searchParams(search).get('iap') !== 'true') {
    return
  }
  try {
    sessionStorage.setItem(IAP_STORAGE_KEY, 'true')
  } catch {
    // A tab that cannot store the flag stays on web checkout.
  }
}

export function isIapRequested() {
  try {
    return sessionStorage.getItem(IAP_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}
